import React, { useCallback, useMemo } from "react";
import { ListRenderItem, Platform } from "react-native";
import Animated, {
  scrollTo,
  useAnimatedRef,
  useAnimatedScrollHandler,
  useDerivedValue,
  useSharedValue,
} from "react-native-reanimated";
import { Box } from "arkh";
import {
  ColumnItem,
  RowItem,
  COLUMN_WIDTH,
  FIRST_ROW_HEIGHT,
} from "./components";
import { TaskOccasionItem } from "./TaskOccasionItem";

export function useGrid({
  onGridItemPress,
}: {
  onGridItemPress(
    columnIndex: number,
    taskId: string,
    prevImportance: "REQUIRED" | "OPTIONAL" | null
  ): void;
}) {
  const headerScrollRef = useAnimatedRef<Animated.ScrollView>();
  const bodyScrollRef = useAnimatedRef<Animated.ScrollView>();
  const headerScroll = useSharedValue(0);
  const bodyScroll = useSharedValue(0);

  if (Platform.OS !== "web") {
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDerivedValue(() => {
      scrollTo(headerScrollRef, headerScroll.value, 0, false);
    });
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDerivedValue(() => {
      scrollTo(bodyScrollRef, bodyScroll.value, 0, false);
    });
  }
  const bodyScrollHandler = useAnimatedScrollHandler({
    onScroll: (e) => {
      headerScroll.value = e.contentOffset.x;
    },
  });

  const headerScrollHandler = useAnimatedScrollHandler({
    onScroll: (e) => {
      bodyScroll.value = e.contentOffset.x;
    },
  });
  const bodyRenderGridItem: ListRenderItem<{
    tasks: { importance: "OPTIONAL" | "REQUIRED" | null; taskId: string }[];
  }> = useCallback(
    ({ item, index }) => {
      return (
        <ColumnItem>
          {item.tasks.map((task, taskIndex) => {
            return (
              <RowItem key={`${index}${taskIndex}`}>
                <TaskOccasionItem
                  status={task.importance}
                  onPress={() => {
                    onGridItemPress(index, task.taskId, task.importance);
                  }}
                />
              </RowItem>
            );
          })}
        </ColumnItem>
      );
    },
    [onGridItemPress]
  );
  const bodyGetItemLayout = useCallback(
    (_: unknown, index: number) => ({
      offset: index * COLUMN_WIDTH,
      length: COLUMN_WIDTH,
      index,
    }),
    []
  );
  const bodyFooter = useMemo(
    () => <Box style={{ width: FIRST_ROW_HEIGHT }} />,
    []
  );
  return {
    body: {
      footer: bodyFooter,
      scrollHandler: bodyScrollHandler,
      ref: bodyScrollRef,
      renderGridItem: bodyRenderGridItem,
      getItemLayout: bodyGetItemLayout,
    },
    header: {
      scrollHandler: headerScrollHandler,
      ref: headerScrollRef,
    },
  };
}
